import storeModule from "./store";

let config;

const validateOptions = (options) => {
  if (!options.store) throw new Error("Please provide a Vuex store");

  return options;
};

const registerStoreModule = () => {
  config.store.registerModule("liveCoach", storeModule);
};

export default {
  install(Vue, options) {
    config = validateOptions(options);
    Vue.prototype.$_liveCoach_config = config;
    registerStoreModule();
  },
};



// WEBPACK FOOTER //
// ./~/vue-components/live-coach/index.js